export default "__VITE_ASSET__BJKy9hGi__"